/* eslint-disable react/prefer-es6-class, react/prop-types, react/jsx-no-bind */
import React from 'react';
import classnames from 'classnames';
import { t } from 'es6/services/localization';
import PanelMixin from 'es6/components/apps/settings/panel-mixin';

export default React.createClass({
  displayName: 'IKnowQuizSettingsPanel',

  mixins: [PanelMixin],

  statics: {
    getTabName() {
      return t('quiz settings');
    },
  },

  /**
   * Helper method to update the quiz options.
   *
   * @param {String} quizOption
   * @param {Boolean} value
   */
  _handleQuizOptionsChange(quizOption, value) {
    const attrs = {
      apps: {
        itemStudy: {
          quizOptions: {
            [quizOption]: value,
          },
        },
      },
    };

    this.props.onDataChange.call(this, attrs);
  },

  /**
   * @param {Boolean} showTranscription
   */
  _handleShowTranscriptionChange(showTranscription) {
    const attrs = {
      apps: {
        showTranscription,
      },
    };

    this.props.onDataChange.call(this, attrs);
  },

  render() {
    // These settings must be disabled while in session.
    const spellingAndAudioClassName = classnames('setting', { disabled: this.props.inSession });
    const quizOptions = this.props.userSettings.apps.itemStudy.quizOptions;
    const audioHandler = this._handleQuizOptionsChange.bind(null, 'audio');
    const spellingHandler = this._handleQuizOptionsChange.bind(null, 'spelling');
    const showTranscription = this.props.userSettings.apps.showTranscription;

    return (
      <div className="quiz-settings">
        <div className="content-columns">
          <div className="content-column">
            <div className={spellingAndAudioClassName}>
              <h4>{t('spelling quiz')}</h4>
              {this._renderToggle('spelling', quizOptions.spelling, this.props.inSession, spellingHandler)}
            </div>

            <div className={spellingAndAudioClassName}>
              <h4>{t('audio quiz')}</h4>
              {this._renderToggle('audio', quizOptions.audio, this.props.inSession, audioHandler)}
            </div>

            {this._renderTypingSpecialCharactersToggle()}

            <div className="setting">
              <h4>{t('show transcription')}</h4>
              {this._renderToggle('showTranscription', showTranscription, false, this._handleShowTranscriptionChange)}
            </div>
          </div>
        </div>
      </div>
    );
  },
});
